"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=void 0;var _react=require("react"),ReduxFirestoreContext=(0,_react.createContext)(null),_default=ReduxFirestoreContext;exports.default=_default,module.exports=exports.default;
//# sourceMappingURL=ReduxFirestoreContext.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-firebase/es/ReduxFirestoreContext.js
// module id = 214
// module chunks = 0